import PropTypes from 'prop-types';
import { Badge, Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import React from 'react';

export default function DataSourceCard({ source, onHover }) {
    const navigate = useNavigate();
    const desc = source.description;

    const categories = source.category || [];

    return (
        <Card
            className="data-card h-100 border-0 shadow-sm"
            onClick={() => navigate(`/data/sources/${source.id}`)}
            role="button"
            tabIndex={0}
            aria-label={`View details for ${source.name}`}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    navigate(`/data/sources/${source.id}`);
                }
            }}
            onMouseEnter={() => onHover?.(source.id)}
            onMouseLeave={() => onHover?.(null)}
        >
            <Card.Body className="d-flex flex-column">
                <div className="d-flex justify-content-between align-items-start mb-2">
                    <Card.Title className="h6 text-primary mb-0 me-2">
                        {source.name}
                    </Card.Title>
                    {source.api_type && (
                        <Badge
                            bg="info"
                            className="text-uppercase flex-shrink-0"
                        >
                            {source.api_type}
                        </Badge>
                    )}
                </div>
                <Card.Text className="text-body-secondary small flex-grow-1 data-card-desc">
                    {desc}
                </Card.Text>
                <div className="d-flex flex-wrap gap-1 mb-2">
                    {categories.slice(0, 3).map((cat) => (
                        <Badge
                            key={cat}
                            bg="light"
                            text="dark"
                            className="fw-normal"
                        >
                            {cat}
                        </Badge>
                    ))}
                </div>
                <div className="d-flex justify-content-between align-items-center mt-auto">
                    <small className="text-muted">
                        {source.organization || 'Unknown org'}
                    </small>
                    {source.update_frequency && (
                        <small className="text-muted">
                            {source.update_frequency}
                        </small>
                    )}
                </div>
            </Card.Body>
        </Card>
    );
}

DataSourceCard.propTypes = {
    source: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string,
        api_type: PropTypes.string,
        category: PropTypes.arrayOf(PropTypes.string),
        organization: PropTypes.string,
        update_frequency: PropTypes.string,
    }).isRequired,
    /** Called with source ID on mouse enter, null on mouse leave */
    onHover: PropTypes.func,
};
